import moment from 'moment-timezone';

/*
import {
  CustomDateRange,
  DateRange,
  RelativeDateRange,
} from '../types/date-range';

export const relativeToLabel = (
  dateRange: RelativeDateRange,
  withRounded: boolean = true,
) => {
  const value =
    typeof dateRange.value === 'string'
      ? parseInt(dateRange.value, 10)
      : dateRange.value;

  let unitCountLabel: string = '';
  let suffix: string = '';
  if (value === 0) {
    if (dateRange.unit === 'day') {
      unitCountLabel = 'Today';
    } else {
      unitCountLabel = `This ${dateRange.unit}`;
    }
  } else if (value === 1) {
    if (dateRange.unit === 'day') {
      unitCountLabel = 'Yesterday';
    } else {
      unitCountLabel = `${value} ${dateRange.unit}`;
      suffix = 'ago';
    }
  } else if (value > 1) {
    unitCountLabel = `${value} ${dateRange.unit}s`;
    suffix = 'ago';
  }
  if (dateRange.round && withRounded) {
    suffix = `${suffix} (rounded)`;
  }
  if (suffix) {
    return `${unitCountLabel} ${suffix}`;
  }
  return unitCountLabel;
};

 */

export const toCustomDateRange = (
  dateRange,
  timezone,
) => {
  if (dateRange.type === 'relative') {
    const { value, unit, round } = dateRange;
    const now = moment.tz(timezone);

    let start = now
      .clone()
      .subtract(value, `${unit}s`);
    if (round) {
      start = start.startOf(unit === 'week' ? 'isoWeek' : unit);
    }
    return {
      type: 'absolute',
      start: start.toISOString(),
      end: now.toISOString(),
    };
  }
  return dateRange;
};

/*
export function isRelativeDateRange(
  dateRange: DateRange,
): dateRange is RelativeDateRange {
  return dateRange.type === 'relative';
}

export function isAbsoluteDateRange(
  dateRange: DateRange,
): dateRange is CustomDateRange {
  return dateRange.type === 'absolute';
}

export function getDefaultDateRange(): RelativeDateRange {
  return {
    type: 'relative',
    value: 0,
    unit: 'week',
    round: true,
  };
}

export function formatDateRangeToString(
  dateRange: DateRange,
  timezone: string,
  format: string = 'LLL',
) {
  if (isRelativeDateRange(dateRange)) {
    const { start } = toCustomDateRange(dateRange, timezone);
    const startStr = moment.tz(start, timezone).format(format);

    return `${startStr} to now`;
  } else {
    const { start, end } = dateRange;
    const startStr = moment.tz(start, timezone).format(format);
    const endStr = moment.tz(end, timezone).format(format);

    return `${startStr} - ${endStr}`;
  }
}

 */
